import Utilities from "./components/Utilities";
import {Forms} from "./components/Forms/Forms";
import {Modals} from "./components/Modals";
import GetAddress from "./components/GetAddress";
import Wysiwyg from "./components/Wysiwyg";
import {Filepond} from "./components/Filepond";
import {Alerts} from "./components/Alerts";
import Tooltips from "./components/Tooltips";
import {InputMasks} from "./components/InputMasks";
import {Stripe} from "./components/Stripe";
import {Tables} from "./components/Tables/Tables";
import {Dropdowns} from "./components/Dropdowns/Dropdowns";
import Repeater from "./components/Repeater";
import JSTree from "./components/JSTree";
import ProductAttributes from "./components/ProductAttributes";
import CUProducts from "./components/CUProducts";
import RunningTotals from "./components/Financials/RunningTotals";
import StockOrders from "./components/StockOrders";
import Orders from "./components/Orders";
import {Charts} from "./components/Charts";
import {OrderValidation} from "./components/OrderValidation";
import ShippingRates from "./components/ShippingRates";
import {StockTake} from "./components/StockTake";

export class Components {

    constructor(selector, alerts = true) {

        Tables.init(selector);
        Dropdowns.selectize(selector);
        InputMasks.inputMasks(selector);
        Utilities.date_pickers(selector);
        Utilities.date_range_pickers(selector);
        Utilities.passwordView(selector);
        Utilities.anchors(selector);
        Utilities.jsTrees(selector);
        Utilities.disableWhen(selector);
        Utilities.initSortable(selector)
        Utilities.displayWhens(selector);
        Utilities.notificationRead(selector);
        Forms.ajaxSubmit(selector);
        Forms.autoSubmit(selector);
        Modals.init(selector);
        GetAddress.initGetAddress(selector);
        Wysiwyg.wysiwyg(selector);
        Tooltips.tooltips(selector);
        Repeater.JRepeater(selector);
        JSTree.categoryTree(selector);
        Filepond.init(selector);
        CUProducts.init(selector);
        ProductAttributes.init(selector);
        RunningTotals.initRunningTotals(selector);
        Utilities.variableAmendments(selector);
        StockOrders.products(selector);
        StockOrders.suppliers(selector)
        Stripe.init(selector);
        Charts.init(selector);
        OrderValidation.init(selector);
        ShippingRates.init(selector);
        StockTake.init();
        Orders.initCompletedItemsShipping();


        /** Alerts */
        if(alerts)
            Alerts.init();

    }
}
